import _ from '@/utils/lodash-optimized'

import http from '../../lib/http'

export const GET_HISTORY = 'notifications/GET_HISTORY'
export const GET_HISTORY_SUCCESS = 'notifications/GET_HISTORY_SUCCESS'
export const GET_HISTORY_FAIL = 'notifications/GET_HISTORY_FAIL'

export const MARK_READ = 'notifications/MARK_READ'

export const UPDATE_HISTORY = 'notifications/UPDATE_HISTORY'
export const PATCH_HISTORY = 'notifications/PATCH_HISTORY'
export const HISTORY_LOADING_START = 'notifications/HISTORY_LOADING_START'
export const HISTORY_LOADING_END = 'notifications/HISTORY_LOADING_END'
export const HISTORY_EMPTY = 'notifications/HISTORY_EMPTY'

export const LOAD_LIMIT = 20

const setHistory = (notifications) => ({
  type: GET_HISTORY_SUCCESS,
  notifications
})

export const getHistory = () => dispatch => {
  dispatch({ type: GET_HISTORY })

  return http
    .getRequest(`/notifications-history?limit=${LOAD_LIMIT}`, {}, { clientName: false })
    .then(data => {
      dispatch(setHistory(data))

      if (data.length === 0 || data.length < LOAD_LIMIT) {
        dispatch({ type: HISTORY_EMPTY })
      }
    })
    .catch(error => {
      dispatch({
        type: GET_HISTORY_FAIL,
        error
      })
    })
}

export const markRead = id => dispatch => {
  http.postRequest(`/notifications-history/${id}/read`, {}).catch(console.warn)
  return dispatch({
    type: MARK_READ,
    id
  })
}

const updateHistory = list => ({
  type: UPDATE_HISTORY,
  notifications: list
})

export const loadMoreHistory = () => (dispatch, getState) => {
  dispatch({ type: HISTORY_LOADING_START })

  const {
    notificationsHistory: { notifications }
  } = getState()

  const minId = notifications.length ? _.last(notifications).id : false
  const query = minId
    ? `/notifications-history?toId=${minId}&limit=${LOAD_LIMIT}`
    : `/notifications-history?limit=${LOAD_LIMIT}`

  return http.getRequest(query, {}, { clientName: false }).then(resp => {
    const nots = notifications.concat(resp)
    dispatch({ type: HISTORY_LOADING_END })
    dispatch(updateHistory(nots))

    if (resp.length === 0 || resp.length < LOAD_LIMIT) {
      dispatch({ type: HISTORY_EMPTY })
    }
  })
}
